"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAccount = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const typeorm_1 = require("typeorm/browser");
const data_ui_1 = require("../data-ui");
const enums_1 = require("../data-ui/enums");
const layouts_1 = require("../data-ui/layouts");
const address_1 = require("./address");
const reasons_for_pause_enum_1 = require("./reasons-for-pause-enum");
const user_role_enum_1 = require("./user-role-enum");
class BaseAccount {
    constructor() {
        this.shippingAddress = new address_1.ShippingAddress();
    }
}
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ generated: true, length: 18 }),
    (0, typeorm_1.Index)('hcu_idx_account_sfid', { unique: true }),
    (0, typeorm_1.PrimaryColumn)('character varying', {
        length: 18,
        name: 'id',
        default: () => "gid_generate_sfid('001')",
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('enum', {
        enum: user_role_enum_1.UserRoleEnum,
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "role", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Column)('character varying', {
        length: 80,
        nullable: true,
        name: 'persontitle',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "title", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Column)('character varying', {
        length: 40,
        nullable: false,
        default: '',
        name: 'salutation',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "salutation", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Column)('character varying', {
        length: 40,
        nullable: true,
        name: 'firstname',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "firstName", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Column)('character varying', {
        length: 80,
        nullable: true,
        name: 'lastname',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "lastName", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 40,
        nullable: true,
        name: 'billingfirstname',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "billingFirstName", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 80,
        nullable: true,
        name: 'billinglastname',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "billingLastName", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 40,
        nullable: true,
        name: 'productdeliveryfirstname',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "productDeliveryFirstName", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 80,
        nullable: true,
        name: 'productdeliverylastname',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "productDeliveryLastName", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Product Delivery Address Company Name' }),
    (0, typeorm_1.Column)('text', {
        name: 'delivery_address_company_name',
        nullable: true,
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "deliveryAddressCompanyName", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)('idx_trgm_account_name', { synchronize: false }),
    (0, typeorm_1.Column)('character varying', {
        length: 255,
        nullable: false,
        name: 'name',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "name", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Company Name (for Customer Only)' }),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 128,
        name: 'companyname__c',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "companyName", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 128,
        name: 'billingcompanyname',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "billingCompanyName", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Column)('character varying', {
        length: 80,
        nullable: true,
        name: 'personemail',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "email", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 80,
        name: 'emailforinvoices__c',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "emailForInvoices", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        default: true,
        nullable: false,
        name: 'email_communication__c',
    }),
    __metadata("design:type", Boolean)
], BaseAccount.prototype, "emailCommunication", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 80,
        name: 'emailfororders__c',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "emailForOrders", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        length: 40,
        nullable: true,
        name: 'phone',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "phone", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        length: 40,
        nullable: true,
        name: 'personmobilephone',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "mobilePhone", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => address_1.ShippingAddress),
    (0, typeorm_1.Column)((type) => address_1.ShippingAddress, {
        prefix: '',
    }),
    __metadata("design:type", address_1.ShippingAddress)
], BaseAccount.prototype, "shippingAddress", void 0);
__decorate([
    (0, typeorm_1.Column)((type) => address_1.BillingAddress, {
        prefix: '',
    }),
    __metadata("design:type", address_1.BillingAddress)
], BaseAccount.prototype, "billingAddress", void 0);
__decorate([
    (0, typeorm_1.Column)((type) => address_1.AddressOptional, {
        prefix: 'productdelivery',
    }),
    __metadata("design:type", address_1.AddressOptional)
], BaseAccount.prototype, "productDeliveryAddress", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        default: false,
        nullable: true,
        name: 'gid_factoring_target_enabled__c',
    }),
    __metadata("design:type", Boolean)
], BaseAccount.prototype, "gidFactoringTargetEnabled", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 18,
        name: 'factoring_account__c',
        nullable: true,
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "factoringAccount", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        nullable: true,
        name: 'umsatzsteuer_befreit__c',
    }),
    __metadata("design:type", Boolean)
], BaseAccount.prototype, "vatExempt", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
        name: 'iban__c',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "iban", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
        name: 'bic__c',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "bic", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'accounting_per_job__c',
        nullable: true,
    }),
    __metadata("design:type", Boolean)
], BaseAccount.prototype, "accountingPerJob", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        length: 18,
        name: 'invoicerecipient__c',
        nullable: true,
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "invoiceReceipient", void 0);
__decorate([
    data_ui_1.DataUi.EnumValues(enums_1.LOCALES),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
        name: 'language__c',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "language", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 40,
        nullable: true,
        name: 'accountsource',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "accountsource", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 255,
        nullable: true,
        name: 'country__c',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "country", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 18,
        nullable: true,
        name: 'ownerid',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "ownerid", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        default: false,
        nullable: true,
        name: 'newaccount__c',
    }),
    __metadata("design:type", Boolean)
], BaseAccount.prototype, "newaccount", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 255,
        nullable: true,
        name: 'website',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "website", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        nullable: true,
        name: 'description',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "description", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 4099,
        nullable: true,
        name: 'qualifications__c',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "qualifications", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 4099,
        nullable: true,
        name: 'rejected_brands__c',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "rejected_brands", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 4099,
        nullable: true,
        name: 'services_of_interest__c',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "services_of_interest", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 255,
        nullable: true,
        name: 'import_id__c',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "import_id", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 255,
        nullable: true,
        name: 'source__c',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "source", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 255,
        nullable: true,
        name: 'logo__c',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "logo", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 255,
        nullable: true,
        name: 'referral_source__c',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "referral_source", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 255,
        nullable: true,
        name: 'unlisted_qualifications__c',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "unlisted_qualifications", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 255,
        nullable: true,
        name: 'language__pc',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "language_pc", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 4099,
        name: 'servicesofinterest__c',
        nullable: true,
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "servicesofinterest", void 0);
__decorate([
    (0, typeorm_1.Column)('enum', {
        enum: reasons_for_pause_enum_1.ReasonsForPauseEnum,
        nullable: true,
        name: 'reasonforpause__c',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "reasonForPause", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        length: 18,
        nullable: true,
        name: 'default_contact__c',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "default_contact", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        nullable: true,
        name: 'notes__c',
    }),
    __metadata("design:type", String)
], BaseAccount.prototype, "notes", void 0);
__decorate([
    (0, typeorm_1.Column)('timestamp without time zone', {
        nullable: true,
        name: 'nextstepdate__c',
    }),
    __metadata("design:type", Date)
], BaseAccount.prototype, "nextStepDate", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        default: false,
        nullable: true,
        name: 'signedpartneragb__c',
    }),
    __metadata("design:type", Boolean)
], BaseAccount.prototype, "signedPartnerTc", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        default: false,
        nullable: false,
    }),
    __metadata("design:type", Boolean)
], BaseAccount.prototype, "preventInvoicingAutomation", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        default: false,
        nullable: false,
    }),
    __metadata("design:type", Boolean)
], BaseAccount.prototype, "showInvoiceMaterialSection", void 0);
exports.BaseAccount = BaseAccount;
//# sourceMappingURL=base-account.js.map